import { store, useAppSelector } from '@reduxStore';

/**
 * Hook used for accessing the current Terminal from state.
 */
export default function useCurrentTerminal() {
	const terminal = useAppSelector((state) => state.applicationState.selectedTerminal);

	if (!terminal) {
		throw new Error('No terminal is currently selected.');
	}

	return terminal;
}

export function getTerminalNumber() {
	/** Get the terminal number from redux  */
	const terminalNumber = store.getState().applicationState.selectedTerminal?.number;
	if (!terminalNumber) {
		throw new Error('Terminal Number is required.');
	}
	return terminalNumber;
}
